import type { CSSProperties, ImgHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface MapleMarketLeafProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  className?: string;
  style?: CSSProperties;
}

export default function MapleMarketLeaf({ className, style, ...props }: MapleMarketLeafProps) {
  return (
    <img
      src="/os/assets/icons/maple-market.svg"
      alt=""
      aria-hidden="true"
      width={28}
      height={28}
      draggable={false}
      className={cn('h-7 w-7 shrink-0 object-contain', className)}
      style={style}
      {...props}
    />
  );
}